(function () {
  function isMobile() {
    return window.matchMedia("(max-width: 989px)").matches;
  }

  function closeAll(except) {
    document.querySelectorAll(".brandbar .mwl-brand-item.has-submenu").forEach((li) => {
      if (li !== except) li.classList.remove("is-open");
    });
  }

  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".brandbar .mwl-toggle");
    if (!btn) return;

    // Su desktop il submenu è hover (CSS). Su mobile apro a tap.
    if (!isMobile()) return;

    e.preventDefault();
    e.stopPropagation();

    const item = btn.closest(".brandbar .mwl-brand-item.has-submenu");
    if (!item) return;

    const willOpen = !item.classList.contains("is-open");

    closeAll(item);

    if (willOpen) item.classList.add("is-open");
    else item.classList.remove("is-open");
  });

  // Chiudi cliccando fuori
  document.addEventListener("click", function (e) {
    if (!isMobile()) return;
    if (e.target.closest(".brandbar")) return;
    closeAll(null);
  });
})();
